import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';
import type { TypeProductMenuCode } from '~/constants/product';

import { productKeys } from './keys';

/**
 * [상품관리] 공통 코드 조회 API
 * @param menuCode 메뉴 코드
 */
export const fetchCodesMenuMenuCode = async <T>(menuCode: TypeProductMenuCode): Promise<T> => {
  const { data } = await axiosInstance.get<{ data: T }>(`${API_ENDPOINT.PRODUCT.GET_PRODUCT_CODES_MENU}/${menuCode}`);
  return data.data;
};

type UseGetCodesMenuMenuCodeQueryOptions<TData, TSelected> = {
  menuCode: TypeProductMenuCode;
  enabled?: boolean;
  dimmed?: boolean;
  select?: (data: TData) => TSelected;
};

/**
 * [상품관리] 공통 코드 조회 Query Hook
 * @description 상품 필터 옵션, 상태코드 등 공통코드 조회
 */
export const useGetCodesMenuMenuCodeQuery = <TData = unknown, TSelected = TData>({
  menuCode,
  enabled = true,
  dimmed = true,
  select,
}: UseGetCodesMenuMenuCodeQueryOptions<TData, TSelected>) => {
  return useQuery({
    queryKey: productKeys.codesMenu(menuCode),
    queryFn: () => fetchCodesMenuMenuCode<TData>(menuCode),
    staleTime: 1000 * 60 * 30,
    enabled,
    meta: { dimmed },
    select,
  });
};
